import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useCreateNews = () => {
  const token = useAuthToken();
  const createNews = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/news", credentials, token);
  };

  return createNews;
};

export const useGetNews = () => {
  const token = useAuthToken();
  const getNews = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }
    return apiRequest("get", "/api/news", null, token);
  };

  return getNews;
};

export const useUpdateNews = (id) => {
  const token = useAuthToken();

  const updateNews = async (formData) => {
    if (!token) {
      throw new Error("Token is missing");
    }
    const response = await apiRequest(
      "patch",
      `/api/news/${id}`,
      formData,
      token
    );

    return response;
  };

  return updateNews;
};
